import { conditionalServiceWorkerInstall } from './opus2/util/serviceWorkerRegistration';
import { Router } from './opus2/router/router';
import { backgroundFetchChunks } from './opus2/router/background-job/background-fetch-chunks';

const currentURL = globalThis.location.href;
if(currentURL.includes('nblysbx') || currentURL.includes('nblydev') || currentURL.includes('nblytest') || currentURL.includes('localhost')) {
    void (async () => {
        const { default: LocationInterceptor } = await import (/* webpackChunkName: "redirect-guard" */'./opus2/redirect-interceptor/locationInterceptor');
        const locationInterceptor = LocationInterceptor.getInstance();
        locationInterceptor.init();
    })();
}

conditionalServiceWorkerInstall();
export * from './opus2';
export * from './global';

const router = Router.getInstance();
router.init();
window.addEventListener("load", () => {
    backgroundFetchChunks();
});
